export const normalizeFolderDisplayName = (folderName = "") => {
  const safeValue = String(folderName ?? "").trim();

  if (!safeValue) {
    return "";
  }

  return safeValue
    .toUpperCase()
    .replace(/DOCUMENTACION/gi, "DOCUMENTACIÓN")
    .replace(/MEDICOS/gi, "MÉDICOS")
    .replace(/PROVISION/gi, "PROVISIÓN");
};
